import { Skeleton, Typography } from "@mui/material"
import { groupBy } from "../../../../helpers/helpers";
import MuiInput from "../../../../components/mui-input/MuiInput";
import { UseFormReturn } from "react-hook-form";
import { StyledAddSystem } from "./AddSystem.styled";
import { AccountAdd } from "../../../../models/account";
import { useGetAccountStructureQuery } from "../../../../redux/api/accounts-structure.api";
import { useTheme } from "@emotion/react";


interface AddSystemProps {
  useForm: UseFormReturn<AccountAdd>
}


function AddSystem({ useForm }: AddSystemProps) {

  const theme = useTheme();

  const { 
    data: systemStructure,
    isFetching,
  } = useGetAccountStructureQuery("מערכת");

  const structureSortedByTitle = groupBy(systemStructure, "account_title")
  const customFieldsExist = structureSortedByTitle?.["מותאם אישית"]?.find(structure=> !!structure.show_form === true);

  return (
    <StyledAddSystem>
      {isFetching && (<Skeleton variant="rectangular" height={500} animation="wave" sx={{ bgcolor: theme.colors.section_color }} />)}
      {!isFetching && systemStructure &&
        <>
          <div>
            <Typography variant="body1">פרטים</Typography>
            <div className="fields">
              {structureSortedByTitle?.["פרטים"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            {customFieldsExist && (<Typography variant="body1">שדות מותאמים אישית:</Typography>)}
            <div className="fields">
              { structureSortedByTitle?.["מותאם אישית"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

        </>}

    </StyledAddSystem>
  )
}

export default AddSystem